import PatientsList from './_PatientsList';

export default PatientsList;
